// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1Sv-y","rootCenter":"LoadMoreObserver_rootCenter__pGJwk","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1kk2s"};